import React, { useContext } from 'react';
import { useQuery } from '@apollo/react-hooks';
import { QUERY_PRODUCER_PROFILE } from 'graphql/queries';
import Layout from './LayoutView';
import withMenu from './withMenu';
import withRoutes from './withRoutes';
import { compose } from 'react-apollo';
import { KeycloakContext } from 'components/Secured';
import { adminAssistantOrganization } from 'utils/productAssistantAccess';

const RoleLayout = compose(withMenu, withRoutes)(Layout);

const LayoutContainer = props => {
    const keycloakContext = useContext(KeycloakContext);
    const supportedRole = props.role === 'producer' || props.role === 'store';
    const { data, loading, error } = useQuery(QUERY_PRODUCER_PROFILE, {
        skip: !supportedRole,
        fetchPolicy: 'cache-and-network',
    });
    const enableProductAssistant = (props.role === 'admin' && Boolean(adminAssistantOrganization(keycloakContext?.keycloak))) ||
        (supportedRole && !loading && !error && data?.userProducer?.enableProductAssistant === true);
    const enableInsights = props.role === 'producer' && !loading && !error && data?.userProducer?.enableInsights === true;
    return <RoleLayout {...props} enableProductAssistant={enableProductAssistant} enableInsights={enableInsights} />;
};
export default LayoutContainer;
